<div class="loader">
    <div class="dimmed" [hidden]="status != STATUS_LOADING">
        <div class="dimmed_flex">
            <div class="dimmed_content dimmed_versions">
                <div class="dimmed_title"></div>
                <div class="dimmed_subtitle"></div>
                <div class="dimmed_subtitle"></div>
            </div>
            <div class="dimmed_status"></div>
        </div>
    </div>
    <!-- <core-helpers-box-loading [hidden]="status != STATUS_LOADING"></core-helpers-box-loading> -->
</div>
<div *ngIf="status == STATUS_DONE" class="versions-details-main" [ngClass]="{'with-overlay': modalView == MODAL_VIEW_FILES_SIGNED_ERROR }">
    <core-layout-modal-feedback class="modal-feedback" *ngIf="modalView == MODAL_VIEW_FILES_SIGNED_ERROR"
        [type]="'fail'"
        [message]="'Error'"
        [text]="'There was some problems getting your file with signatures. Please try again. If the error persists, please reach out to our support team through the Help Me button.'"
        [buttonText]="'Discard'"
        (action)="dismmisError($event)">
    </core-layout-modal-feedback>
    <versions-details-content-info 
        [version]="version"
        (feedbackDone)="onFeedbackDone($event)"
        (versionShareStatusUpdated)="onShareVersionStatusUpdated($event)"
    ></versions-details-content-info>

    <!-- files list when we have feedbacks to display notes & send shared files as well-->
    <version-details-files-notes
        [version]="version"
        [menu]="menu"
        [myShare]="myShare"
        [versionShares]="versionShareList"
        [sharedWithMe]="sharedFileIds"
        (action)="onMenuClick($event)"
    ></version-details-files-notes>
    <!-- approval feedback messages -->
    <!-- show only feedback messages and urls to add feedback message when access -->
    <version-details-content-messages-version-share-feedback
        *ngIf="accessFeedbacks && (
                (versionShareMessages != null && versionShareMessages.length > 0) ||
                (versionShareList.length > 0 )
            )"
        [version]="version"
        [versionShares]="versionShareList"
        [versionShareMessages]="versionShareMessages"
        [myShare]="myShare"
    ></version-details-content-messages-version-share-feedback>
    <!-- messages -->
    <!-- EASY UPDATE: is TO FORCE QUIT access to feeddbacks to show only real version messages -->
    <version-details-content-messages
        *ngIf="access!= null && access.access_version_read_comments"
        [version]="version"
    ></version-details-content-messages>
</div>
